import React from 'react';
import PropTypes from 'prop-types';
import { Pie } from 'react-chartjs-2';

export default class PieChart extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    options: PropTypes.object,
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  static defaultProps = {
    data: [],
  };

  render() {
    return (
      <Pie
        data={{
          labels: this.props.labels,
          datasets: [
            {
              backgroundColor: this.props.colors,
              data: this.props.data,
              borderWidth: 0,
            },
          ],
        }}
        options={{
          legend: {
            position: 'right',
          },
          maintainAspectRatio: false,
          ...this.props.options,
        }}
      />
    );
  }
}
